import http from '../common/services/HttpService';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ISubmission } from '../common/entities';

interface SubmissionsResponse {
  submissions: ISubmission[];
}

export interface SubmissionFilters {
  status?: string;
  mission?: string;
  user?: string;
}

const useSubmissions = (filters?: SubmissionFilters) => {
  return useQuery<SubmissionsResponse, Error>({
    queryKey: ['submissions', filters],
    queryFn: () =>
      http.get<ISubmission, SubmissionsResponse>('/submissions', {
        params: filters,
      }),
  });
};

export const useScoreSubmission = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, score }: { id: string; score: number }) =>
      http.put(`/submissions/${id}/score`, { score }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['submissions'] });
    },
  });
};

export const usePendingSubmissionsCount = () => {
  return useQuery<number, Error>({
    queryKey: ['submissions', 'pending-count'],
    queryFn: () =>
      http
        .get<ISubmission, SubmissionsResponse>('/submissions', {
          params: { status: 'pending' },
        })
        .then((res) => (res as unknown as SubmissionsResponse).submissions.length),
    refetchInterval: 30000,
  });
};

export default useSubmissions;
